<template>
    <div v-if="data">
        <div class="overlay" @click="closePopup"  :class="{'show': openQuickDiamondView}"></div>
        <div class="bottom-sheet quick-view-container" :class="{'show':openQuickDiamondView}">
            <div class="quick-view">
                <div class="steps_close">
                    <SvgHeaderSvg class="largesvg" @click="closePopup" :type="'close'" />
                </div>

                <div class="quick-view-content" >
                    <div class="images-container">
                        <CyoLooseQuickViewDiamondImageSlider
                        :images="{
                            diamond_image: data?.thumb_image,
                            json_video: data?.video
                            }"
                        :data="data"
                        />
                    </div>
                    <!-- :is_supplier_stone="data?.is_supplier_stone"
                    :is_fiery_round = "data?.is_fiery_round"    -->

                    <h4 class="title font-active">{{ data.carat }} carat {{ data.shape }} diamond</h4>
    
                    <h5 class="text-center price">
                        {{ $formatPrice(data.price) }}
                    </h5>
                    <div class="diam-details d-flex justify-content-between">
                        <div class="flex"> 
                            <p class="value">{{ data.carat }} Ct</p>
                            <p class="text">Carat</p>
                        </div>
                        <div class="flex  text-uppercase">
                            <p class="value">{{ data.color }}</p>
                            <p class="text">Color</p>
                        </div>
                        <div class="flex ">
                            <p class="value">{{ data.cut }}</p>
                            <p class="text">Cut</p>
                        </div>
                        <div class="flex ">
                            <p class="value">{{ data.clarity }} </p>
                            <p class="text">Clarity</p>
                        </div>
                        <div class="flex  text-uppercase border-0">
                            <p class="value">{{ data.lab }}</p>
                            <p class="text">Lab</p>
                        </div>
                    </div>
                    <div class="d-flex gap-3 btn-container">
                        <button class="cta_btn details-btn" @click="$emit('openDetailsPage',data.slug)">DETAILS</button>
                        <div v-if="moduleType != 'loose'" class="w-100">
                            <button v-if="!showLoader" class="cta_btn diamond-btn" @click="chooseDiamond()">CHOOSE THIS Diamond</button>
                            <button v-else class="cta_btn diamond-btn">PLEASE WAIT...</button>
                        </div>
                        <div v-else class="w-100">
                            <button v-if="!showLoader" class="cta_btn diamond-btn" @click="addToCart()">add to cart</button>
                            <button v-else class="cta_btn diamond-btn">PLEASE WAIT...</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
    import { cyoStore }  from '@/stores/cyo/cyo';
    import { cyodetailStore }  from '@/stores/cyodetail/cyodetail';
    import { cartStore } from '@/stores/cart/cart';

    const storeCart = cartStore()

    const {$formatPrice,$selectdiamondGtag, $toast} = useNuxtApp()
    const localePath = useLocalePath()
    const route = useRoute()
    const router = useRouter()

    const props = defineProps(['data','openQuickDiamondView'])
    const emits = defineEmits(['closeDiamondQuickView','openDetailsPage'])

    const moduleType = route.meta.moduleType
    const moduleSubType = route.meta.moduleSubType

    const storeCyo = cyoStore();
    const store = cyodetailStore();

    const showLoader = ref(false)

    function closePopup(){
        emits('closeDiamondQuickView')
    }

    const item = computed(() => {
        const item = store.getDiamondDetail()

        return item
    })

    const chooseDiamond = ()=>{
        selectDiamond()
        closePopup()
    }

    const selectDiamond = async ()=> {
        const settings = {moduleType: moduleType ,moduleSubType: moduleSubType , slug: props.data.slug }
        await store.setDiamondForDetailPage( settings)
        // emits('productUrl', type)

        showLoader.value = true
        let modifiedModuleSubType

        if(moduleSubType === 'ring'){
            modifiedModuleSubType = 'ring'
        }
        else if(moduleSubType === 'pendant'){
            modifiedModuleSubType = 'pendant'
        }
        else{
            modifiedModuleSubType = moduleSubType
        }

      

        const isCompatible = storeCyo.checkCompatibility(  { moduleSubType: modifiedModuleSubType,  page: 'diamond' } )

        if(!isCompatible){
                    // this.$refs['my-modal'].show()
            alert('The diamond and the product setting you have selected are not compatible.')
            return
        }

        await storeCyo.setDiamond({ item: {...item.value}, moduleSubType: modifiedModuleSubType } )
        $selectdiamondGtag(modifiedModuleSubType);

        const diamond = storeCyo.getDiamond(modifiedModuleSubType)
        const setting = storeCyo.getSetting(modifiedModuleSubType)

        if (diamond && setting) {
            return router.push( localePath( {name: 'cyo-complete-'+modifiedModuleSubType, query:{ sid: setting.metal.id, did: diamond.id }}) ); 
        }
        
        showLoader.value = false
        return router.push( localePath( {name: 'cyo-setting-list-'+modifiedModuleSubType} ) ); 

    }

    async function addToCart(){
        let params = {
            item_id: props.data.id,
            module_type: 'loose',
            has_appraisal:0
        }
        let url = useCountryPath('/diamond/add/session')
        showLoader.value = true
        try{
            const response = await $fetch(url, {
                method: 'POST',
                body: params
            })
            if (response.success) {
                showLoader.value = false
                storeCart.setCartCount()

                $toast('success', 'Congratulations!', 'Item added to cart');
                // setTimeout(()=>{
                //     window.location.href = localePath( {path: '/cart'});
                // }, 1500);
            }
        }
        catch(err){
            showLoader.value = false
            $toast('alert', 'OOPS!', err.response?._data?.errors);
        }
    }

    onBeforeUnmount(()=>{
       closePopup()
    })


</script>

<style scoped>

.overlay{
    position: fixed;
    bottom: -100%;
    left: 0;
    height: 0;
    width: 100%;
    background: #0000007a;
    z-index: 99;
    transition: 0.1s;
    pointer-events: auto;
}

.overlay.show{
    bottom: 0;
    height: 100%;
    transition-delay: 0.1s;

}

.bottom-sheet{
    position: fixed;
    bottom: -200px;
    left: 0;
    height: 0;
    width: 100%;
    background-color: #fff;
    transition: 1s;
    z-index: 100;
}

.bottom-sheet.show{
    height: 570px;
    max-height: 90vh;
    bottom: 0;
    transition: 0.6s;
}

.quick-view-container {
    padding: 12px;
    border-radius: 8px 8px 0 0;
    background: #fff;
    width: 100%;
    overflow: auto;
}

.images-container{
    height: 300px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.diam-details{
    margin: 30px auto;
    max-width: 500px;
    width: 100%;
}

.flex{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border-right: 1px solid #eaeaea;
    flex: 1;
}

.flex p{
    margin: 0;
}

.flex .text{
    font-size: 12px;
    text-transform: uppercase;
    color: #606060;
}

.flex .value{
    font-weight: bold;
    font-size: 16px;
    color: #353535;
}

h4.title {
    font-size: 18px;
    color: #212529;
    text-align: center;
    text-transform: capitalize;
}

h5.price {
    font-size: 18px;
    color: var(--green);
    font-weight: 600;
    margin-top: 16px;
}

.metals-box{
    margin: 32px auto;
}

.btn-container{
    max-width: 360px;
    margin:auto;
}

.cta_btn {
    border: 1px solid var(--green);
    text-align: center;
    border-radius: 4px;
    text-transform: uppercase;
    font-size: 14px;
    font-weight: bold;
    letter-spacing: 1.12px;
    padding: 12px 16px;
    /* min-width: 100px; */
}

.cta_btn.details-btn{
    color: var(--green);
    background-color: #fff;
    min-width: 100px;
}

.cta_btn.diamond-btn{
    padding: 12px;
    color: #fff;
    background-color: var(--green);
    width: 100%;
}

.steps_close {
    text-align: right;
    margin-bottom: 5px;

}

.largesvg {
    transform: scale(1.3);
}
</style>